import * as React from 'react';
import { object as PropObject } from 'prop-types';

import { Search } from '../gs-core/client';
import { Organization } from '../gs-core/common';

import { FilterParamsModel, MAX_TITLE_LENGTH, Subject } from '../common/models';
import { ServiceRegistry } from '../services';

interface TitleSearchProps {
  title?: string;
  unit?: Organization;
  subject?: Subject;
  autoFocus?: boolean;
  onSelect?: (value: string) => void;
  onSubmit?: (value: string) => void;
  onTextChange?: (value: string) => void;
}

interface TitleSearchState {}

export class TitleSearch extends React.Component<TitleSearchProps, TitleSearchState> {
  static contextTypes = { services: PropObject };

  private searchComponent: Search<string> | null = null;

  constructor(props: TitleSearchProps) {
    super(props);
    this.state = {};
  }

  findTitles = async (query: string): Promise<string[]> => {
    const { titleService, errorLogger } = this.context.services as ServiceRegistry;

    try {
      const filter = FilterParamsModel.create({
        title: query,
        owningUnitId: this.props.unit && this.props.unit.id,
        subjectUserId: this.props.subject && this.props.subject.user.id,
        subjectType: this.props.subject && this.props.subject.type
      });

      const page = await titleService.find(filter);

      return page.records.map(title => title.title);
    } catch (err) {
      await errorLogger.log(err);
      return [];
    }
  };

  changeValue = (value: string) => {
    if (this.props.onTextChange) {
      this.props.onTextChange(value);
    }
  };

  select = (value: string) => {
    if (this.props.onSelect) {
      this.props.onSelect(value);
    }
  };

  submit = (value: string) => {
    if (this.props.onSubmit) {
      this.props.onSubmit(value);
    }
  };

  focus = () => this.searchComponent && this.searchComponent.focus();

  render() {
    return (
      <Search
        load={this.findTitles}
        maxLength={MAX_TITLE_LENGTH}
        minLength={0}
        onSelect={this.select}
        onSubmit={this.submit}
        onTextChange={this.changeValue}
        placeholder="Title search"
        autoFocus={this.props.autoFocus || false}
        value={this.props.title}
        ref={(component: Search<string> | null) => this.searchComponent = component}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/TitleSearch/TitleSearch.tsx